import React from 'react'

const Footer = () => {
  return (
    <div style={{textAlign:'center' ,marginBottom:10}}>
        Made with by Pragya and Rimi ❤ 
    </div>
  )
}

export default Footer